import React, {
  FunctionComponent as Component,
  useEffect,
  useState
} from "react";
import JsBarcode, { BaseOptions } from "jsbarcode";
import * as Gtin from "../models/GTIN";
import { isOk } from "../result";

interface BarcodeProps {
  gtin: string;
  options?: Omit<BaseOptions, "format">;
}

export const Barcode: Component<
  BarcodeProps & React.HTMLProps<HTMLCanvasElement>
> = ({ gtin, options, ...props }) => {
  const ref = React.createRef<HTMLCanvasElement>();
  const [ean, setEan] = useState<string>();

  useEffect(() => {
    const parsed = Gtin.fromString(gtin);

    if (!isOk(parsed)) {
      return;
    }

    setEan(parsed.value.toString());
  }, [gtin]);

  useEffect(() => {
    if (!ean) {
      return;
    }

    JsBarcode(ref.current, ean);
  }, [ean, ref]);

  return <canvas {...props} ref={ref} />;
};
